// Retrieve Firebase Messaging object.
import React from "react";
import firebase from "../assets/libs/firebase";
import {API_ENDPOINT, FIREBASE_MESSAGING_PUBLIC_KEY, X_AUTHORIZATION,} from "./constants";
import Alert from "react-s-alert";
import {clearStorage} from "./storage";
import CryptoJS from "crypto-js";
import {isSafari} from "./browser";
import strings from "./strings";
import Less_than_12 from "../assets/images/12A@3x.png";
import More_than_12 from "../assets/images/15@3x.png";
import More_than_15 from "../assets/images/18@3x.png";
import Ucert from "../assets/images/U CERT.svg";
import className from "classnames";
import {updateProfanityWordToFireStore} from "../util/firebase/firestore";
import * as Sentry from "@sentry/react";
import moment from "moment";
import assets from "./assets";

let messaging = null;
let showAvailabilityFucntion;

if (!isSafari()) {
    messaging = firebase.messaging();
}

export const subscribeToAvailabilityCall = (availablity) => {
    showAvailabilityFucntion = availablity;
};

export const signInAnonymously = () => {
    firebase
        .auth()
        .signInAnonymously()
        .then(function (data) {
        })
        .catch(function (error) {
            // Handle Errors here.
        });
};

if (messaging) {
    // [START receive_message]
    // Handle incoming messages. Called when:
    // - a message is received while the app has focus
    // - the user clicks on an app notification created by a service worker
    //   `messaging.setBackgroundMessageHandler` handler.
    messaging.onMessage(function (payload) {
        //console.log('Message received. ', payload);
        // [START_EXCLUDE]
        // Update the UI to include the received message.
        // [END_EXCLUDE]
        if (payload.hasOwnProperty("data") && payload.data.hasOwnProperty("type")) {
            let type = payload.data.type;
            switch (type) {
                case 100:
                    //broadcaster approved
                    break;
                case "1300":
                    // console.log("1300--->",payload)
                    // setTimeout(() => {
                    //   showAvailabilityFucntion(payload);
                    // },1000)
                    break;
                case "1400":
                    // console.log("1400--->",payload)
                    // setTimeout(() => {
                    //   showAvailabilityFucntion(payload);
                    // },1000)
                    break;
            }
        }
    });
}

export const required = (value) => (value ? undefined : "Required");

export const setInitialState = (state) => {
    return {
        ...state,
        isFetching: false,
        isSuccess: false,
        isError: false,
        error: null,
    };
};

export const isEmpty = (obj) => {
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false;
    }
    return true;
};

export const requestPush = (callback) => {
    if (messaging) {
        // Add the public key generated from the console here.
        messaging.usePublicVapidKey(FIREBASE_MESSAGING_PUBLIC_KEY);

        // messaging.requestPermission().then(function () {
        //     ////console.log('Notification permission granted.');
        //     // TODO(developer): Retrieve an Instance ID token for use with FCM.
        //
        // }).catch(function (err) {
        //     console.error('Unable to get permission to notify.', err);
        // });

        // Get Instance ID token. Initially this makes a network call, once retrieved
        // subsequent calls to getToken will return from cache.
        messaging
            .getToken()
            .then((currentToken) => {
                if (currentToken) {
                    vuePayLog(
                        "utility.js",
                        "getToken",
                        `getToken :: currentToken = ${currentToken}`
                    );
                    //sendTokenToServer(currentToken);
                    //updateUIForPushEnabled(currentToken);
                } else {
                    // Show permission request.
                    vuePayLog(
                        "utility.js",
                        "getToken",
                        "No Instance ID token available. Request permission to generate one."
                    );
                    // Show permission UI.
                    //updateUIForPushPermissionRequired();
                    //setTokenSentToServer(false);
                }
            })
            .catch((err) => {
                console.error("An error occurred while retrieving token. ", err);
                //showToken('Error retrieving Instance ID token. ', err);
                //setTokenSentToServer(false);
            });

        // Callback fired if Instance ID token is updated.
        messaging.onTokenRefresh(() => {
            messaging
                .getToken()
                .then((refreshedToken) => {
                    vuePayLog(
                        "utility.js",
                        "onTokenRefresh",
                        `Token refreshed. :: refreshedToken = ${refreshedToken}`
                    );
                    // Indicate that the new Instance ID token has not yet been sent to the
                    // app server.
                    //setTokenSentToServer(false);
                    // Send Instance ID token to app server.
                    //sendTokenToServer(refreshedToken);
                    // ...
                })
                .catch((err) => {
                    console.error("Unable to retrieve refreshed token ", err);
                    //showToken('Unable to retrieve refreshed token ', err);
                });
        });
    }
};

export const getFirebaseToken = (callback) => {
    if (messaging) {
        // [START get_token]
        // Get Instance ID token. Initially this makes a network call, once retrieved
        // subsequent calls to getToken will return from cache.
        messaging
            .getToken()
            .then(function (currentToken) {
                if (currentToken) {
                    callback(currentToken);
                } else {
                    // Show permission request.
                    console.error(
                        "No Instance ID token available. Request permission to generate one."
                    );
                    requestPush();
                    // Show permission UI.
                    // updateUIForPushPermissionRequired();
                    // setTokenSentToServer(false);
                }
            })
            .catch(function (err) {
                //LogException("utility.js", "getFirebaseToken", err.message)
            });
        // [END get_token]
    }
};

export const vuepayAlert = (type, message, callback) => {
    if (type === "warning") {
        Alert.warning(message, {
            position: "top-right",
            effect: "stackslide",
            onShow: function () {
                if (callback !== undefined && typeof callback === "function") {
                    callback();
                }
            },
            offset: 50,
        });
    } else if (type === "success") {
        Alert.success(message, {
            position: "top-right",
            effect: "stackslide",
            onShow: function () {
                if (callback !== undefined && typeof callback === "function") {
                    callback();
                }
            },
            offset: 50,
        });
    } else if (type === "error") {
        Alert.error(message, {
            position: "top-right",
            effect: "stackslide",
            onShow: function () {
                if (callback !== undefined && typeof callback === "function") {
                    callback();
                }
            },
            offset: 50,
        });
    } else {
        Alert.info(message, {
            position: "top-right",
            effect: "stackslide",
            onShow: function () {
                if (callback !== undefined && typeof callback === "function") {
                    callback();
                }
            },
            offset: 50,
        });
    }
};

export const logout = (history) => {
    clearStorage().then((isCleared) => {
        if (isCleared) {
            // if (history) {
            //     history.push("/login")
            // } else {
            window.location.href = "/dashboard/login";
            // }
        }
    });
};

export const getSessionPaymentTitle = (broadcast) => {
    // broadcast.hasOwnProperty("private") ? "Paid session" : broadcast.broadcast_type === "paid" ? "Paid group session" : "Free session"
    if (broadcast.hasOwnProperty("private")) {
        //user is in private session
        if (parseInt(broadcast.one_to_one_session_price) === 0) {
            //user is in free group session
            return "Free session";
        } else {
            //user is in free group session
            return "Paid private session";
        }
    } else if (broadcast.broadcast_type === "paid") {
        //user is in group session
        return "Paid group session";
    } else {
        //user is in free group session
        return "Free session";
    }
};

export const getSessionPaymentDescription = (broadcast) => {
    if (typeof broadcast !== "undefined") {
        if (
            broadcast.hasOwnProperty("private") &&
            broadcast.hasOwnProperty("one_to_one_session_price")
        ) {
            //user is in private session
            if (parseInt(broadcast.one_to_one_session_price) === 0) {
                //user is in free group session
                return "No charge for this session";
            } else {
                //user is in free group session
                return `Paid session charge ${getFormattedPrice(
                    broadcast.one_to_one_session_price,
                    false
                )}`;
            }
        } else if (
            broadcast.hasOwnProperty("broadcast_type") &&
            broadcast.broadcast_type === "paid" &&
            broadcast.hasOwnProperty("group_session_price")
        ) {
            //user is in group session
            return `Group session charge ${getFormattedPrice(
                broadcast.group_session_price,
                false
            )}`;
        } else {
            //user is in free group session
            return "No charge for this session";
        }
    }

    return "No charge for this session";
};

export const getFormattedPrice = (price, isShortForm = true) => {
    if (price >= 100) {
        return isShortForm
            ? `£${(price / 100).toFixed(2)}/min`
            : `£${(price / 100).toFixed(2)} per minute`;
    } else {
        if(price === "Free"){
            return "Free";
        }else{
            return isShortForm ? `${price}p/min` : `${price}p per minute`;
        }
    }
};

export const formattedPrice = (price) => {
    if (price >= 100) {
        return `£${(price / 100).toFixed(2)}`;
    } else {
        return `${price}P`;
    }
};

export const handleUnauthorizedAccess = (action, state, res) => {
    if (res) {
        if (res.status === 401) {
            logout();
            vuepayAlert("error", "Session expired, please login.", () => {
                logout();
            });
        }
        if (res.status === 500) {
            vuepayAlert("error", "Sorry, something went wrong.");
        }
        return {
            status: res.status,
            statusText: res.statusText,
        };
    } else {
        return {
            status: "Network request failed",
        };
    }
};

export const navigate = (props, screen) => {
    switch (screen) {
        case "broadcaster_register_pending":
            props.history.push("/broadcaster/register/pending");
            break;
        case "broadcaster_create_profile":
            props.history.push("/broadcaster/create/profile");
            break;
        case "broadcaster_availability":
            props.history.push("/broadcaster/availability");
            break;
        case "broadcaster_create_availability":
            props.history.push("/broadcaster/create/availability");
            break;
        case "broadcaster_create_broadcast":
            props.history.push("/broadcaster/create/broadcast");
            break;
        case "broadcaster_start_broadcast_countdown":
            props.history.push("/broadcast/start/countdown");
            break;
        case "broadcaster_start_broadcast":
            props.history.push("/broadcaster/start/broadcast");
            break;
    }
};

// regex : min 1 Special char, 1 Uppercase, 1 Lowercase, 1 number, min 6 characters allowed & max 100 characters allowed
export const isValidPassword = (value) =>
    value &&
    !/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?([^\w\s]|[_])).{6,100}$/.test(
        value
    )
        ? value.length < 6
        ? strings.validation.password_minimum_length
        : value.length > 100
            ? strings.validation.password_maximum_length
            : undefined
        : undefined;

export const encrypt = (value) => {
    try {
        return CryptoJS.AES.encrypt(JSON.stringify(value), X_AUTHORIZATION);
    } catch (error) {
        LogException("utility.js", "encrypt", error.message);
        return null;
    }
};

export const decrypt = (storedValue) => {
    try {
        const bytes = CryptoJS.AES.decrypt(storedValue.toString(), X_AUTHORIZATION);
        const plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    } catch (error) {
        LogException("utility.js", "encrypt", error.message);
        return null;
    }
};

/**
 * this function is set to capture all logs on the platform and report it back to Log.io
 * @param screeName
 * @param functionName
 * @param message
 */
export const vuePayLog = (screeName, functionName, message) => {
    //TODO Logz.io
    if (API_ENDPOINT !== "https://api.vuepay.com/api/v1") {
        //exclude logs for production environments
        if (message === undefined) {
            console.info(`${screeName} >> ${functionName}`);
        } else {
            console.info(`${screeName} >> ${functionName}`, message);
        }
    }
};

/**
 * this function is set to capture all exceptions on the platform and report it back to sentry
 * @param screeName
 * @param functionName
 * @param error
 * @constructor
 */
export const LogException = (screeName, functionName, error) => {
    console.error(`${screeName} >> ${functionName}`, error);
    Sentry.captureMessage(`${screeName} >> ${functionName} >> ${error}`, "error");
};

/**
 * this function works similar like jquery function $(".className").remove(".className");
 * @param targetClassName
 * @param removeClassName
 */
export const removeClass = (targetClassName, removeClassName) => {
    // Get desired elements
    const element = document.getElementsByClassName(targetClassName);

    // Iterate through the retrieved elements and add the necessary class names.
    for (let itr = 0; itr < element.length; itr++) {
        element[itr].classList.remove(removeClassName);
    }
};

export const getSearchQuery = () => {
    const searchInput = document.getElementsByName("searchInput")[0];
    return searchInput ? searchInput.value : "";
};

/**
 * the function takes in a parameter locationSearch of the form ?param1=some_value&param2=some_value
 * this function would always return a object
 * @param locationSearch
 */
export const getUrlParameters = (locationSearch) => {
    let parameters = {};

    locationSearch.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
        parameters[key] = value;
    });

    return parameters;
};

/**
 * the function takes in the modal instance i.e. modal = document.getElementById("modal-id");
 * @param modal
 */
export const showModal = (modal) => {
    if (modal) {
        modal.classList.add("show");
        modal.style.display = "block";
        document.getElementsByClassName("modal-overlay")[0].style.display = "block";
    }
};

export const hideModal = (modal) => {
    if (modal) {
        modal.classList.remove("show");
        modal.style.display = "none";
        document.getElementsByClassName("modal-overlay")[0].style.display = "none";
    }
};

export const resetSearchField = () => {
    const searchInput = document.getElementsByName("searchInput")[0];
    if (searchInput) {
        searchInput.value = "";
    }
};

export const checkIfUserIsOnBroadcasterSection = () => {
    return window.location.pathname.indexOf("/broadcaster") >= 0;
};

export const removeAllModalPopUps = () => {
    const listOfModals = Array.from(document.getElementsByClassName("modal"));

    listOfModals.map((modal) => {
        modal.classList.remove("show");
        modal.style.display = "none";
    });
    document.getElementsByClassName("modal-overlay")[0].style.display = "none";
};

export const toggleRightBar = () => {
    document
        .getElementsByClassName("rightNotification")[0]
        .classList.toggle("expanded");
    document.getElementsByClassName("notify")[0].classList.toggle("expanded");
};

export const logErrorToMyService = (info,error) => {
    //TODO log this
    console.error(`logErrorToMyService >> ${info}`,error);
};

export const makeUserOnline = (userId) => {
    const oldRealTimeDb = firebase.database();
    oldRealTimeDb.ref("status/" + userId).set("online");

    oldRealTimeDb
        .ref("status/" + userId) // Making a reference to a key-value pair in the old real-time database structure
        .onDisconnect() // Setting up the onDisconnect hook
        .set("offline");
};

export const getCDNImage = ($bucket, $key, $width, $height) => {
    // Define the string
    let requestBody = "";

    if ($height) {
        requestBody = JSON.stringify({
            bucket: $bucket,
            key: $key,
            edits: {
                resize: {
                    width: $width,
                    height: $height,
                    fit: "contain",
                },
            },
        });
    } else {
        requestBody = JSON.stringify({
            bucket: $bucket,
            key: $key,
            edits: {
                resize: {
                    width: $width,
                    fit: "contain",
                },
            },
        });
    }

    // Encode the String
    const encodedString = btoa(requestBody);
    return `https://dgsnexqo3t7f4.cloudfront.net/${encodedString}`;
};

export const getStatusDiv = (status, extraClassName) => {
    let classNames = "";
    if (status === 0 || status === "offline") {
        classNames = className("offline-circle", `${extraClassName}`);
    } else if (status === 1 || status === "online") {
        classNames = className("online-circle", `${extraClassName}`);
    } else if (status === 2 || status === "private") {
        classNames = className("busy-circle", `${extraClassName}`);
    }
    return <div className={classNames}/>;
};

export const getStatus = (status) => {
    {/*0 => Offline, 1 => Online, 2 = > Private*/
    }
    switch (status) {
        case 0:
            return assets.clipstore.home.status.away;
        case 1:
            return assets.clipstore.home.status.online;
        case 2:
            return assets.clipstore.home.status.busy;
    }
}

export const getAgeGroupDiv = (age_group,className = "age-group") => {
    switch (age_group) {
        case "less_than_12":
            return <img src={Ucert} className={className}/>;
        case "more_than_12":
            return <img src={Less_than_12}  className={className}/>;
        case "more_than_15":
            return <img src={More_than_12} className={className}/>;
        case "18":
            return <img src={More_than_15} className={className}/>;
    }
};

/**
 * @function this method remove profanity word from existing content
 * @param id - broadcaster or user
 * @param wordList
 * @param content
 * @param replaceContent - if content from search then pass false
 * @param isViewer - user is viewer or broadcaster identification
 */
export const removeWordFromList = (
    id,
    wordList,
    content,
    replaceContent,
    isViewer
) => {
    // return content.replace(
    //     /\b\w+/g,
    //     word => wordList.some(item => item.toUpperCase() === word.toUpperCase()) ? '' : word
    //   );
    let data = wordList.join("|");
    let customPattern = new RegExp(data, "ig");
    if (content.match(customPattern)) {
        let profanityWord = content.match(customPattern);
        content = replaceContent ? content.replace(customPattern, "") : content;
        id && updateProfanityWordToFireStore(id, profanityWord[0], isViewer);
    }
    return content;
};

export const openYotiIframe = (url) => {
    const modal = document.getElementById("common-modal");
    hideModal(modal);
    openIframe(url);
};

export const openIframe = (url) => {
    if (url) {
        const modal = document.getElementById("common-modal-iframe");
        showModal(modal);
        const modalExist = document.getElementById("yotiFrame");
        if (modalExist !== null) {
            modalExist.src = url;
        } else {
            var iframe = document.createElement("iframe");
            iframe.style.width = "100%";
            iframe.style.height = "auto";
            iframe.style.border = "none";
            iframe.id = "yotiFrame";
            iframe.allow = "camera;microphone";
            iframe.src = url;
            var yotiContainer = document.getElementById("yotiContainerIframe");
            yotiContainer.appendChild(iframe);
        }
    }
};

export const getStatusBadge = (status) => {
    switch (status) {
        case "live":
            return "badge badge-danger badge-font";
        case "private":
            return "badge badge-danger badge-font";
        case "available":
            return "badge badge-success badge-font";
        case "awaiting":
            return "badge badge-primary badge-font";
        default:
            break;
    }
};

export const getTimeDifference = (now, then) => {
    return moment
        .utc(
            moment(now, "DD/MM/YYYY HH:mm:ss").diff(
                moment(then, "DD/MM/YYYY HH:mm:ss")
            )
        )
        .format("HH:mm:ss");
};

export const updateVideoDimensions = () => {
    const navigationBarHeight = 56;
    const navigationBarPadding = 100;
    const topSectionHeight = 64;
    const footerHeight = 61;
    const paddingFromBottom = 42;
    let videoContainerHeight = window.innerHeight - (navigationBarHeight + navigationBarPadding + topSectionHeight + paddingFromBottom);

    if (window.innerHeight === window.screen.height) {
        videoContainerHeight = window.innerHeight;
    }
    let videoContainerWidth = 1000;

    const videoContainerClass = document.getElementsByClassName("video-container"),
        OTPublisherContainer = document.getElementsByClassName("OTPublisherContainer"),
        OTSubscriberContainer = document.getElementsByClassName("OTSubscriberContainer"),
        OTVideoElement = document.getElementsByClassName("OT_video-element"),
        chatComponentContainer = document.getElementsByClassName(" chat-component-container"),
        chatListItem = document.getElementsByClassName("chat-list-item-ul"),
        chatComponentMainContentContainer = document.getElementsByClassName("chat-component-main-content-container"),
        tabContent = document.getElementsByClassName("tab-content"),
        tabPane = document.getElementsByClassName("tab-pane"),
        listOfRequest = document.getElementsByClassName("list-of-request"),
        tipGoalMiddleContent = document.getElementsByClassName("tip-goal-middle-content"),
        successfulTippingMiddleContent = document.getElementsByClassName("successful-tipping-middle-content");


    if (videoContainerClass && videoContainerClass[0]) {
        videoContainerWidth = videoContainerClass[0].offsetWidth;
        videoContainerClass[0].style.height = `${videoContainerHeight}px`;
    }

    if (OTSubscriberContainer && OTSubscriberContainer[0]) {
        OTSubscriberContainer[0].style.width = `${videoContainerWidth}px`;
        OTSubscriberContainer[0].style.height = `${videoContainerHeight}px`;
    }

    if (OTPublisherContainer && OTPublisherContainer[0]) {
        OTPublisherContainer[0].style.width = `${videoContainerWidth}px`;
        OTPublisherContainer[0].style.height = `${videoContainerHeight}px`;
    }

    if (OTVideoElement && OTVideoElement[0]) {
        OTVideoElement[0].style.width = `${videoContainerWidth}px`;
        OTVideoElement[0].style.height = `${videoContainerHeight}px`;
    }

    if (OTVideoElement && OTVideoElement[1]) {
        OTVideoElement[0].style.width = `${videoContainerWidth}px`;
        OTVideoElement[0].style.height = `${videoContainerHeight}px`;
    }

    if (chatComponentContainer && chatComponentContainer[0]) {
        chatComponentContainer[0].style.height = `${videoContainerHeight + 16}px`;
    }


    if (chatListItem && chatListItem[0]) {
        chatListItem[0].style.height = `${videoContainerHeight - 56}px`;
    }

    if (tabContent && tabContent[0]) {
        tabContent[0].style.height = `${videoContainerHeight - 61}px`;
    }

    if (tabPane && tabPane[0]) {
        tabPane[0].style.height = `${videoContainerHeight - 61}px`;
    }

    if (tabPane && tabPane[1]) {
        tabPane[1].style.height = `${videoContainerHeight - 61}px`;
    }

    if (chatComponentMainContentContainer && chatComponentMainContentContainer[0]) {
        chatComponentMainContentContainer[0].style.height = `${videoContainerHeight}px`;
        chatComponentMainContentContainer[0].style.minHeight = `${videoContainerHeight}px`;
    }

    if (listOfRequest && listOfRequest[0]) {
        listOfRequest[0].style.height = `${videoContainerHeight - 60 - 116}px`;
    }

    if (listOfRequest && listOfRequest[1]) {
        listOfRequest[1].style.height = `${videoContainerHeight - 60 - 116}px`;
    }

    if (tipGoalMiddleContent && tipGoalMiddleContent[0]) {
        tipGoalMiddleContent[0].style.height = `${videoContainerHeight - 60}px`;
    }

    if (successfulTippingMiddleContent && successfulTippingMiddleContent[0]) {
        successfulTippingMiddleContent[0].style.height = `${videoContainerHeight}px`;
    }

};

export const getTagsCommaSeparated = (tagsArray) => {
    let tags = "";
    tagsArray.map((value, index) => {
        if (index === 0) {
            tags = value.name;
        } else {
            tags = `${tags}, ${value.name}`;
        }
    });

    return tags;
};

export const generateUUID = ()=>{
    let uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
            let r = (Math.random() * 16) | 0,
                v = c === "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        }
    );
    return `${uuid}-${new Date().getTime()}`;
}

export const isFileImage =(file) =>{
    return file && file['type'].split('/')[0] === 'image';
}